(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-upcoming.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-upcoming.js');

'use strict';

const {
  resolveCompetitionName
} = svs.components.marketplaceCompetition.helpers;
const {
  IS_NOT_LOGGED_IN
} = svs.components.marketplaceCompetition.overviewHero.constants.OverviewUserState;
const {
  CompetitionLogo,
  LoginButton
} = svs.components.marketplaceCompetition.overviewHero.common;
const CompetitionUpcoming = _ref => {
  let {
    competition,
    userState
  } = _ref;
  const compName = resolveCompetitionName(competition);
  return React.createElement("div", {
    className: "competition-overview-hero competition-upcoming"
  }, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("div", {
    className: "overview-hero-title"
  }, React.createElement("span", null, compName), React.createElement("span", null, "\xE4r snart tillbaka!")), React.createElement("div", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Var med och sl\xE5ss om titeln")), React.createElement(LoginButton, {
    isVisible: userState === IS_NOT_LOGGED_IN
  })));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.content.CompetitionUpcoming', CompetitionUpcoming);

 })(window);